import { isEmpty, noop } from 'lodash'
import React from 'react'
import { useMediaQuery } from 'react-responsive'

import Button from '../../../Button'
import Spinner from '../../../Spinner'
import { TFaData } from '../../types'

type TChooseMethodStep = {
  faData?: TFaData
  changeMethod?: (val: number) => void
}
const ChooseMethodStep = (props: TChooseMethodStep): React.ReactElement => {
  const { faData, changeMethod = noop } = props
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  return (
    <>
      {isEmpty(faData) && (
        <div className="d-flex flex-column align-items-center justify-content-center pt-2">
          <Spinner size={30} />
          {i18n.t(`fa2_loading-title`, `Daten werden abgerufen`)}
        </div>
      )}
      {!isMobile && !isEmpty(faData) && (
        <Button primary className="mb-1 mr-1" onClick={() => changeMethod(0)}>
          {i18n.t(`fa2_qr-code`, `QR Code`)}
        </Button>
      )}
      {isMobile && !isEmpty(faData) && (
        <Button primary className="mb-1 mr-1" onClick={() => changeMethod(1)}>
          {i18n.t(`fa2_as-uri`, `URL`)}
        </Button>
      )}
      {!isEmpty(faData) && (
        <Button primary className="mb-1 mr-1" onClick={() => changeMethod(2)}>
          {i18n.t(`fa2_copy-paste-string`, `Kopieren & einfügen`)}
        </Button>
      )}
    </>
  )
}

export default ChooseMethodStep
